module.exports = __webpack_public_path__ + "static/media/searchIcon.b82f47ba.svg";